var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_49",
    transform: "matrix(0.015625 0 0 0.021875 0 -0.2)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_49",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACP0lEQVR4nO2aT0sVYRTGp4W6ERNsldf6AJltAr9ArXIbZJboxi9gC3EhLtuUbpKElrkp/wRBLgRXRS1q50K5lnW9IISE9I/SGz958YAgmN53ztyZd+75LYeZ8zzngZl558wbRYZhGIZhGIZhGJ4ATUAn0AMMAqPAJDADLAPvgVXgI1AGvgE7HLIjx8pyzqpcsyw1JqXmoGg4raYoDYALwF0xtSiG/1F7KqK9KF7uAB1JNX0FeAJskH02xGuXVvN9wC7h4Tz3xm2+APwmXH4B7XECuEf4DMcJYJ7wmY0TwCbh88W3+Vbyw1mfALrJD1d9AugnP/T5BDBOfhjzCeBxAkauyRq/1jzyCeCFtgupewa4CRSpHXM+AbzTdnGkfgMwBGyRPG98AihquzhGp1meNz9IjjWfAMraLk7QawPuA38ysRgCtrVdVDFvmFaeMXz1CeAnylSp76Y+z5Skv/sEUEGZqk0c+NB4de5ZAIHeAi/TvAW2UeaUuhez8hAso8wJeuey9hosarsIbSH0VttFikvh1z4BLGi7SPFjaDYrn8PXgQ/UnimfAMap84FIP3U+EuumzoeireSHlqoDcAAlwudz5AswR/g8jxPAMHX+c7Qgv5hDxXk/7x2AA7gd6AaJv8CtSAOgK6AtMp/E62WV5o+5Ldy2mYfAK2A9ifHZKaiItvPwQDwVojQAGoFLwA1gABgBJoCnwJLM9FZkV1fpP9vkSnLOilyzJDUmpOaAaDitxlSaNQzDMAzDMAwjygP717fnXeS+tP0AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.336ec3731ff2bd9613c9c3f623b5973d.svg";
export { ForwardRef as ReactComponent };